import { render, staticRenderFns } from "./SubjectLabelSelect.vue?vue&type=template&id=f9de0424"
import script from "./SubjectLabelSelect.ts?vue&type=script&lang=ts&external"
export * from "./SubjectLabelSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./SubjectLabelSelect.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports